import { useConfirm } from 'components/Alert/useConfirm';
import { useMutation } from 'query';
import { undo } from 'scenes/FinancePage/IO/data/queryKeyFactory';
import { undoIO } from 'scenes/FinancePage/IO/sources';

export const useUndo = () => {
  const confirm = useConfirm();

  const approveMutation = useMutation(undo(), undoIO, {
    refresh: true,
    successMessage: () => `IO undone`,
  });

  const handleAction = ({ id }: any) => {
    confirm({
      title: `Undo IO ${id}?`,
      confirmActionLabel: 'Undo',
    }).then(() => approveMutation.mutateAsync({ id }));
  };

  return [handleAction, approveMutation];
};
